export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTUiIGhlaWdodD0iMjMiIHZpZXdCb3g9IjAgMCAxNSAyMyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE0LjUzNSAxOS40MzUxTDYuMTI5IDExLjAyOTFMMTQuNTM1IDIuNjIzMDVMMTEuOTQxIDAuMDI5MDUyN0wwLjk0MTAwNCAxMS4wMjkxTDExLjk0MSAyMi4wMjkxTDE0LjUzNSAxOS40MzUxWiIgLz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/arrow-left-big.svg
// module id = 275
// module chunks = 0 5 6 14